import { Component } from '@angular/core';

@Component({
  selector: 'app-campaign',
  templateUrl: './campaign.component.html',
  styleUrls: ['./campaign.component.css']
})
export class CampaignComponent {


 


  imageUrls: string[] = [];

 
  ngOnInit() {
    // Simulating backend API response
    this.fetchImages();
  }

  fetchImages() {
    // Replace with actual API call if needed
    this.imageUrls = [
      "/assets/images/Slide1.png",
      "/assets/images/Slide2.png",
      "/assets/images/Slide3.png",
      "/assets/images/Slide4.png",
    ];
  }


  
}
